import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../../global/global.service';
import { ResponseBack } from '../generico/generico.model';
import { IActDatosPArticipe } from './actualizacion-datos.model';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActDatosParticipeService {
  private url = `${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/cliente/private/`;
  constructor(private http: HttpClient, private globalService: GlobalService) { }

  getActualizacionDatosParticipe(cuc: string) {
    return this.http.get<ResponseBack<IActDatosPArticipe[]>>(`${this.url}listarActualizacionDatosParticipe/${cuc}`)
    // return of<ResponseBack<IActDatosPArticipe[]>>(this.respList);
  }

  updateActDatos(cuc: string, dataOut: IActDatosPArticipe[]) {
    return this.http.post<ResponseBack<string>>(`${this.url}insertarActualizacionDatosParticipe`, { cuc: cuc, lista: dataOut });
  }



  enviarCorreoActDatos(cuc: string, nombres: string) {
  return this.http.get<ResponseBack<string>>(
    `${this.url}enviarcorreo`,
    {
      params: {
        cuc: cuc,
        nombres: nombres
      }
    }
  );
}

  // respList = {
  //   "datos": [
  //     {
  //       "id": "60707",
  //       "cuc": "44730707",
  //       "nombre": "APELLIDO_PATERNO44730707 APELLIDO_MATERNO, NOMBRE1 NOMBRE2",
  //       "correo": "jcastro@gmd.com.pe",
  //       "telefono": "998877669",
  //       "residente": 1,
  //       "principal": 0
  //     },
  //     {
  //       "id": "86313",
  //       "cuc": "44756313",
  //       "nombre": "APELLIDO_PATERNO44756313 APELLIDO_MATERNO, NOMBRE1 NOMBRE2",
  //       "correo": "pcastro@gmd.com.pe",
  //       "telefono": "567896789",
  //       "residente": 0,
  //       "principal": 0
  //     },
  //   ],
  //   "resultado": {
  //     "codigo": "0",
  //     "descripcion": "Ok"
  //   }
  // }
}
